import { render, staticRenderFns } from "./LegoControlCardDate.vue?vue&type=template&id=fa785b48&scoped=true"
import script from "./LegoControlCardDate.vue?vue&type=script&lang=js"
export * from "./LegoControlCardDate.vue?vue&type=script&lang=js"
import style0 from "./LegoControlCardDate.vue?vue&type=style&index=0&id=fa785b48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa785b48",
  null
  
)

export default component.exports